import { darken } from "polished";
import styled, { css } from "styled-components";
import { color, highContrastStyle, onHover, typeStyle, units, variant, visuallyHidden } from "@m/alchemy-theme";
import { themedInputBackground } from "../form/input/Input.styled";
export const TOGGLE_SIZE = units(2, true);
export const LEFT_PADDING = TOGGLE_SIZE + units(1, true);
export const Control = styled.span `
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: ${TOGGLE_SIZE}px;
  height: ${TOGGLE_SIZE}px;
  background-color: ${({ disabled, checked }) => disabled && !checked
    ? color("hint", { palette: "expressiveNeutral" })
    : highContrastStyle(color("container"), themedInputBackground)};
  border: 1px solid;
  border-radius: ${({ isRadio }) => (isRadio ? `${TOGGLE_SIZE / 2}px` : units(0.5))};
  border-color: ${({ hasError, disabled, ...props }) => hasError
    ? color("base", { palette: "expressiveNegative" })
    : disabled
        ? color("highlight", { palette: "expressiveNeutral" })
        : highContrastStyle(color("base", { palette: "expressiveNeutral" }), darken(0.26, color("lineContrast")(props)))};
`;
export const Input = styled.input `
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: ${TOGGLE_SIZE}px;
  height: ${TOGGLE_SIZE}px;
  opacity: 0;
  cursor: pointer;
  background-color: ${themedInputBackground};
  margin: 0;

  ${onHover(css `
    & + * {
      box-shadow: 0 0 0 3px ${color("highlight", { palette: "interactiveConstructive" })};
    }
  `)}

  [data-whatinput="keyboard"] &:not(:disabled):focus + * {
    box-shadow:
      0 0 0 1px ${color("container")},
      0 0 0 3px ${color("base", { palette: "interactiveConstructive" })};
  }
`;
export const Toggle = styled.span `
  position: absolute;
  display: none;
  top: 50%;
  left: 50%;
  border-style: solid;
  border-color: ${({ disabled, checkStyle }) => disabled || checkStyle === "impliedChecked"
    ? color("highlight", { palette: "interactiveNavigational" })
    : color("base", { palette: "interactiveConstructive" })};
  ${({ isRadio, checkStyle }) => checkStyle
    ? css `
          ${variant("checkStyle", {
        indeterminate: css `
              width: ${TOGGLE_SIZE / 4}px;
              height: ${TOGGLE_SIZE / 2}px;
              border-width: 0 2px 0px 0;
              transform: translate(-50%, -60%) rotate(90deg) scale(1.2, 1.2);
            `,
        impliedChecked: css `
              width: ${TOGGLE_SIZE / 4}px;
              height: ${TOGGLE_SIZE / 2}px;
              border-width: 0 2px 2px 0;
              transform: translate(-50%, -60%) rotate(45deg) scale(1.2, 1.2);
            `
    })}
        `
    : isRadio
        ? css `
            border-width: ${TOGGLE_SIZE / 4}px;
            border-radius: ${TOGGLE_SIZE / 4}px;
            transform: translate(-50%, -50%);
          `
        : css `
            width: ${TOGGLE_SIZE / 4}px;
            height: ${TOGGLE_SIZE / 2}px;
            border-width: 0 2px 2px 0;
            transform: translate(-50%, -60%) rotate(45deg) scale(1.2, 1.2);
          `};
`;
export const Container = styled.label `
  ${typeStyle("bodyS")};

  position: relative;
  min-height: ${TOGGLE_SIZE}px;
  display: ${({ display }) => display};
  padding-left: ${LEFT_PADDING}px;
  cursor: pointer;

  ${Input} + ${Control} ${Toggle} {
    display: ${({ checked, checkStyle }) => (checked || checkStyle ? "block" : "none")};
  }
`;
export const Label = styled.span `
  ${({ shouldVisuallyHideLabel }) => (shouldVisuallyHideLabel ? visuallyHidden() : false)}
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};
  opacity: ${({ disabled }) => disabled && 0.3};
`;
